module.exports = {"master":{"setings":"การตั้งค่า"},"masterCustomer":{"listMasterDataCustomer":"รายชื่อลูกค้า","createMasterDataCustomer":"เพื่มลูกค้า","updateMasterDataCustomer":"อัพเดตข้อมูลลูกค้า","viewMasterDataCustomer":"รายละเอียดลูกค้า","name":"ชื่อ","address":"ที่อยู่","contactNo":"เบอร์ติดต่อ","contactName":"ชื่อผู้ติดต่อ","createCustomer":"เพื่มลูกค้า","":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/master.json
// module id = 749
// module chunks = 116